<template>
    <v-btn :loading="loading" v-on:click="generatePaymentLink" width="350px" color="#eee" elevation="0" height="40px">
        <img src="../../../../../../../public/assets/images/flywire_logo.png" height="25px" />
    </v-btn>
</template>

<script>
import baseUrl from '../../../../../../core/constants/uri';
export default {
    name: 'FlywireButton',
    props: {
        resumen: Object
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        async generatePaymentLink() {
            this.loading = true;
            const studentAccountIds = [];
            const purchase_units = [];
            const authToken = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : '';
            this.resumen.items.subtotal.items.forEach(item => {
                studentAccountIds.push(item.id);
                purchase_units.push({
                    'name': `${item.title}`,
                    'amount': item.monto
                })
            });
            const response = await fetch(`${baseUrl}/flywire/orders`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    'studentAccountIds': studentAccountIds,
                    'purchase_units': purchase_units,
                }),
            })
            this.loading = false;
            const body = await response.json()
            window.open(body.url, '_blank');
            this.$store.commit('commons/SET_SIGNED_USERDATA', true);
            this.$emit('changeStep', 'pending');
        }
    }
}
</script>
